import React, { useState } from "react";
// import { AiOutlineDelete, AiOutlineEdit, AiOutlineSave } from "react-icons/ai";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import uuid from "uuid/dist/v4";
import EditContent from "./EditContent";
import Input from "./Input";
const Content = ({ formData, setFormData, loading }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [content, setContent] = useState({ id: "", header: "", content: "" });

  const handleAppendContent = () => {
    if (content.content === "" || content.header === "") {
      toast.error("Content is empty!");
    } else {
      content.id = uuid();
      formData?.description.push(content);
      setFormData({ ...formData, content: formData.content });
    }
    setContent({ header: "", content: "" });
  };
  const handleChangeContent = (e) => {
    setContent({ ...content, [e.target.name]: e.target.value });
  };
  console.log(formData?.description);
  return (
    <>
      <fieldset className="fieldSet">
        <legend>Description</legend>

        <EditContent
          setFormData={setFormData}
          formData={formData}
          setIsEdit={setIsEdit}
          content={content}
          setContent={setContent}
          isEdit={isEdit}
        />

        <Input
          type="text"
          value={content.header}
          name="header"
          id="header"
          handleChange={handleChangeContent}
          direction="column"
        />
        <label htmlFor="content">Content</label>
        <textarea
          value={content.content}
          type="text"
          name="content"
          id="content"
          onChange={handleChangeContent}
        />
        <button
          type="button"
          disabled={loading}
          onClick={() => {
            isEdit
              ? toast.error("Save your work first!")
              : handleAppendContent();
          }}
        >
          {loading ? "Adding new product..." : "Add Description"}
        </button>
      </fieldset>
    </>
  );
};

export default Content;
